// Shared emoji-mart options. emoji-mart initialises its data once for the whole app, so every
// <Picker> must pass the same values.

// Windows' emoji font (Segoe UI Emoji) has no country flags: they render as two letters
// ("DE", "CN"). emoji-mart's own check draws on a canvas, where Firefox falls back to its
// bundled Twemoji and wrongly reports flags as supported, so hide them on Windows outright.
export const EMOJI_NO_COUNTRY_FLAGS =
  typeof navigator !== "undefined" && /Windows/i.test(navigator.userAgent || "");
